import { Pressable, StyleSheet, View } from 'react-native';
import { router } from 'expo-router';
import { observer } from 'mobx-react';
import Ionicons from '@expo/vector-icons/Ionicons';

import { ThemedText } from '@/components/ThemedText';
import { ThemedView } from '@/components/ThemedView';
import { useScale } from '@/hooks/useScale';
import DefaultBackground from '@/components/DefaultBackground';
import TopbarLogo from '@/components/TopbarLogo';

export default observer(function SubscribeScreen() {
  const styles = useStyles();
  const scale = useScale();

  return (
    <ThemedView style={styles.container}>
      <DefaultBackground />

      {/* Top bar */}
      <View style={styles.topBar}>
        <Pressable
          style={({ focused }) => [
            styles.backButton,
            focused && styles.backButtonFocused,
          ]}
          onPress={() => router.back()}
        >
          <ThemedText style={styles.backButtonText}>Back</ThemedText>
        </Pressable>
        <TopbarLogo />
      </View>

      {/* Content */}
      <View style={styles.content}>
        <Ionicons
          name="lock-closed-outline"
          size={64 * scale}
          color="rgba(255,255,255,0.6)"
          style={{ marginBottom: 24 * scale }}
        />

        <ThemedText style={styles.title}>Subscription Required</ThemedText>

        <ThemedText style={styles.body}>
          Workouts are available to HiNote Life subscribers.
        </ThemedText>

        <ThemedText style={styles.body}>
          To get started, subscribe through the{' '}
          <ThemedText style={styles.highlight}>
            HiNote Life mobile app
          </ThemedText>{' '}
          on your iPhone or Android device.
        </ThemedText>

        <Pressable
          style={({ focused }) => [
            styles.backButtonLarge,
            focused && styles.backButtonLargeFocused,
          ]}
          onPress={() => router.back()}
        >
          <ThemedText style={styles.backButtonLargeText}>Go Back</ThemedText>
        </Pressable>
      </View>
    </ThemedView>
  );
});

function useStyles() {
  const scale = useScale();

  return StyleSheet.create({
    container: {
      flex: 1,
    },
    topBar: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      paddingVertical: 24 * scale,
      paddingHorizontal: 24 * scale,
    },
    backButton: {
      position: 'absolute',
      left: 24 * scale,
      paddingVertical: 8 * scale,
      paddingHorizontal: 20 * scale,
      backgroundColor: 'rgba(255,255,255,0.15)',
      borderRadius: 20 * scale,
      borderWidth: 2,
      borderColor: 'transparent',
    },
    backButtonFocused: {
      backgroundColor: 'rgba(255,255,255,0.3)',
      borderColor: '#fff',
    },
    backButtonText: {
      color: '#fff',
      fontSize: 14 * scale,
      fontWeight: '600',
    },
    content: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 48 * scale,
      paddingBottom: 60 * scale,
    },
    title: {
      color: '#fff',
      fontSize: 32 * scale,
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: 20 * scale,
    },
    body: {
      color: 'rgba(255,255,255,0.75)',
      fontSize: 18 * scale,
      textAlign: 'center',
      lineHeight: 28 * scale,
      marginBottom: 12 * scale,
      maxWidth: 560 * scale,
    },
    highlight: {
      color: '#fff',
      fontWeight: '700',
    },
    backButtonLarge: {
      marginTop: 40 * scale,
      paddingVertical: 16 * scale,
      paddingHorizontal: 48 * scale,
      backgroundColor: 'rgba(255,255,255,0.15)',
      borderRadius: 12 * scale,
      borderWidth: 2,
      borderColor: 'transparent',
    },
    backButtonLargeFocused: {
      backgroundColor: 'rgba(255,255,255,0.3)',
      borderColor: '#fff',
    },
    backButtonLargeText: {
      color: '#fff',
      fontSize: 18 * scale,
      fontWeight: '600',
    },
  });
}
